import { type SerializedPageStructure } from '@wix/document-services-types'

import {
  modifyComponentByVeloId,
  normalizeLastItemMarginInStack,
} from '../utils'
import { FIELD_STACK_VELO_ID } from './veloIds'

export const normalizeLastItemMarginInFieldStack = (
  page: SerializedPageStructure,
): SerializedPageStructure =>
  modifyComponentByVeloId({
    root: page,
    veloId: FIELD_STACK_VELO_ID,
    modifyComponent: fieldStack => normalizeLastItemMarginInStack(fieldStack),
  })
